import zPage from '../Page/page.vue';
import comList from '../../components/com-list.vue';
export default{
    name:'ImformationList',
    data(){
        return{
            page:{
                targetPage:1,
                pageSize:20,
                totalPage:100,
                type:2,
            },
            breadTitle:'行业新闻',
            list:[],
        }
    },
    components:{
        zPage,
        comList,
    },
    created(){
        this.getData();
    },
    methods:{
        getData(){
            this.breadTitle=this.$route.query.type;
            var url="";
            switch(this.breadTitle){
                case '行业新闻':
                    url=this.api.getIndustryPage;
                    break;
                case '政策法规':
                    url=this.api.getPolicyPage;
                    break;
                case '信息通知':
                    url=this.api.getInformationNoticePage;
                    break;
                case '今日头条':
                    url=this.api.getTopPage;
                    break;
                case '焦点回顾':
                    url=this.api.getFocusPage;
                    break;
                case '企业资讯':
                    url=this.api.getCompanyPage;
                    break;

            }
            // var url=this.breadTitle=="行业新闻"?this.api.getIndustryPage:this.api.getPolicyPage;
            var body={
                pageNumber:this.page.targetPage-1,
                pageSize:this.page.pageSize,
            };
            this.get(url,body).then(res=>{
                this.page.totalPage=res.data.totalElements;
                this.list=res.data.list;
                for(var i=0;i<this.list.length;i++){
                    this.list[i].createDate=this.list[i].modifyDate;
                }
            }).catch();
        },
        getDetail(type,id){
            this.$router.push({path:'/informationDetail',query:{type:type,id:id}});
        }
    }
}